import { render, staticRenderFns } from "./orgActive.vue?vue&type=template&id=1bfd6ef2&scoped=true&"
import script from "./orgActive.vue?vue&type=script&lang=js&"
export * from "./orgActive.vue?vue&type=script&lang=js&"
import style0 from "./orgActive.vue?vue&type=style&index=0&id=1bfd6ef2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd6ef2",
  null
  
)

export default component.exports